module.exports = __webpack_public_path__ + "static/media/logo-microsoft-teams-symbol.2b1ebede.svg";